/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';
import type { TileDTO } from './TileDTO';
import {
    TileDTOFromJSON,
    TileDTOFromJSONTyped,
    TileDTOToJSON,
} from './TileDTO';

/**
 * 
 * @export
 * @interface TilePageDTO
 */
export interface TilePageDTO {
    /**
     * 
     * @type {Array<TileDTO>}
     * @memberof TilePageDTO
     */
    content?: Array<TileDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof TilePageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TilePageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TilePageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof TilePageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof TilePageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof TilePageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof TilePageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof TilePageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof TilePageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the TilePageDTO interface.
 */
export function instanceOfTilePageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TilePageDTOFromJSON(json: any): TilePageDTO {
    return TilePageDTOFromJSONTyped(json, false);
}

export function TilePageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TilePageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(TileDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function TilePageDTOToJSON(value?: TilePageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(TileDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

